import React, { useEffect, useRef, useState } from "react";

export const appLinks = [
  { name: 'Insight', url: 'https://insight.ind4.convolink.ai', logo: '/app-logos/Insight.png', desc: 'Analytics & BI' },
  { name: 'Xtract', url: 'https://xtract.ind4.convolink.ai', logo: '/app-logos/Xtract.png', desc: 'Document Extraction' },
  { name: 'KMS', url: 'https://kms.convolink.ai', logo: '/app-logos/KMS.png', desc: 'Knowledge Base Management System' },
  { name: 'QMS', url: 'https://qms.ind4.convolink.ai', logo: '/app-logos/QMS.png', desc: 'Quality Management System' },
  { name: 'Immerse', url: 'https://immerse.ind4.convolink.ai', logo: '/app-logos/Immerse.png', desc: 'Learning Management System' },
  { name: 'HMI', url: 'https://hmi.ind4.convolink.ai', logo: '/app-logos/HMI.png', desc: 'Human Machine Interface' },
  { name: 'Telephony', url: 'https://telephony.ind4.convolink.ai', logo: '/app-logos/Telephony.png', desc: 'Voice & Communications Agents' },
];

export const AppSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredApp, setHoveredApp] = useState(null);
  const switcherRef = useRef(null);

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (switcherRef.current && !switcherRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }} ref={switcherRef}>
      {/* Trigger Button */}
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        style={{
          width: 38,
          height: 38,
          borderRadius: 10,
          background: isOpen ? '#eff6ff' : 'var(--px-surface-hover, #f8fafc)',
          border: isOpen ? '1px solid #bfdbfe' : '1px solid var(--px-border, #e2e8f0)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          padding: 0,
          transition: 'all 0.18s cubic-bezier(0.4, 0, 0.2, 1)',
          outline: 'none',
          boxShadow: isOpen ? '0 0 0 3px rgba(37, 99, 235, 0.12)' : 'none'
        }}
        aria-label="Open applications launcher"
        aria-expanded={isOpen}
        title="Applications Launcher"
        onMouseEnter={(e) => {
          if (!isOpen) {
            e.currentTarget.style.background = '#f1f5f9';
            e.currentTarget.style.borderColor = '#cbd5e1';
          }
        }}
        onMouseLeave={(e) => {
          if (!isOpen) {
            e.currentTarget.style.background = 'var(--px-surface-hover, #f8fafc)';
            e.currentTarget.style.borderColor = 'var(--px-border, #e2e8f0)';
          }
        }}
      >
        <img
          src="/app-logos/fluent_apps-20-regular.svg"
          alt="Apps Launcher"
          style={{
            width: 19,
            height: 19,
            objectFit: 'contain',
            transition: 'transform 0.2s ease',
            transform: isOpen ? 'rotate(90deg)' : 'none',
            opacity: isOpen ? 1 : 0.82
          }}
        />
      </button>

      {/* Popover Dropdown Drawer */}
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            right: 0,
            top: 'calc(100% + 10px)',
            zIndex: 1050,
            width: 336,
            background: '#ffffff',
            border: '1px solid rgba(226, 232, 240, 0.9)',
            borderRadius: 16,
            boxShadow: '0 20px 45px -10px rgba(15, 23, 42, 0.18), 0 8px 16px -6px rgba(15, 23, 42, 0.08)',
            padding: '14px 14px 12px 14px',
            boxSizing: 'border-box',
            animation: 'fadeInUp 0.18s cubic-bezier(0.16, 1, 0.3, 1)',
            backdropFilter: 'blur(8px)'
          }}
        >
          {/* Header Banner */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '2px 4px 12px 4px',
              borderBottom: '1px solid #f1f5f9',
              marginBottom: 10
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span
                style={{
                  fontSize: '0.74rem',
                  fontWeight: 800,
                  letterSpacing: '0.06em',
                  textTransform: 'uppercase',
                  color: '#475569'
                }}
              >
                Convolink Apps
              </span>
              <span
                style={{
                  fontSize: '0.68rem',
                  fontWeight: 600,
                  color: '#2563eb',
                  background: '#eff6ff',
                  padding: '2px 6px',
                  borderRadius: 6,
                  border: '1px solid #dbeafe'
                }}
              >
                Suite
              </span>
            </div>
            <span style={{ fontSize: '0.7rem', color: '#94a3b8', fontWeight: 500 }}>
              {appLinks.length} services
            </span>
          </div>

          {/* 3-Column Apps Grid */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: 8
            }}
          >
            {appLinks.map((app) => {
              const isCurrent = app.name.toLowerCase() === 'propel';
              const isHovered = hoveredApp === app.name;

              return (
                <a
                  key={app.name}
                  href={app.url}
                  target={isCurrent ? '_self' : '_blank'}
                  rel="noopener noreferrer"
                  onClick={() => setIsOpen(false)}
                  onMouseEnter={() => setHoveredApp(app.name)}
                  onMouseLeave={() => setHoveredApp(null)}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 7,
                    padding: '10px 6px 8px 6px',
                    borderRadius: 12,
                    textDecoration: 'none',
                    transition: 'all 0.18s cubic-bezier(0.4, 0, 0.2, 1)',
                    cursor: 'pointer',
                    position: 'relative',
                    background: isCurrent
                      ? (isHovered ? '#eff6ff' : '#f8faff')
                      : (isHovered ? '#f8fafc' : 'transparent'),
                    border: isCurrent
                      ? '1px solid #bfdbfe'
                      : (isHovered ? '1px solid #e2e8f0' : '1px solid transparent'),
                    transform: isHovered ? 'translateY(-2px)' : 'none',
                    boxShadow: isHovered
                      ? '0 6px 14px -3px rgba(15, 23, 42, 0.08)'
                      : 'none'
                  }}
                  title={`${app.name} — ${app.desc || 'Launch app'}`}
                >
                  {/* Current Active App Indicator Badge */}
                  {isCurrent && (
                    <span
                      style={{
                        position: 'absolute',
                        top: 5,
                        right: 5,
                        width: 6,
                        height: 6,
                        borderRadius: '50%',
                        background: '#2563eb',
                        boxShadow: '0 0 0 2px #ffffff'
                      }}
                      title="Current App"
                    />
                  )}

                  {/* App Icon Well */}
                  <div
                    style={{
                      width: 46,
                      height: 46,
                      borderRadius: 12,
                      background: '#ffffff',
                      border: '1px solid #edf2f7',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 7,
                      boxSizing: 'border-box',
                      boxShadow: isHovered
                        ? '0 4px 10px rgba(0, 0, 0, 0.06)'
                        : '0 1px 3px rgba(0, 0, 0, 0.04)',
                      transition: 'all 0.18s ease'
                    }}
                  >
                    <img
                      src={app.logo}
                      alt={app.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        transition: 'transform 0.18s ease',
                        transform: isHovered ? 'scale(1.08)' : 'scale(1)'
                      }}
                      onError={(e) => {
                        e.currentTarget.src = '/app-logos/placeholder.svg';
                      }}
                    />
                  </div>

                  {/* App Label */}
                  <div style={{ textAlign: 'center', width: '100%', padding: '0 2px' }}>
                    <div
                      style={{
                        fontSize: '0.78rem',
                        fontWeight: 600,
                        color: isCurrent ? '#1d4ed8' : '#0f172a',
                        lineHeight: 1.2,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                    >
                      {app.name}
                    </div>
                    {isCurrent && (
                      <span
                        style={{
                          fontSize: '0.62rem',
                          fontWeight: 700,
                          color: '#2563eb',
                          letterSpacing: '0.02em',
                          textTransform: 'uppercase',
                          display: 'block',
                          marginTop: 1
                        }}
                      >
                        Active
                      </span>
                    )}
                  </div>
                </a>
              );
            })}
          </div>

          {/* Footer Bar */}
          <div
            style={{
              marginTop: 10,
              paddingTop: 8,
              borderTop: '1px solid #f1f5f9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingLeft: 4,
              paddingRight: 4
            }}
          >
            <span style={{ fontSize: '0.7rem', color: '#94a3b8', fontWeight: 500 }}>
              Connected workspace
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppSwitcher;

